var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApplicationBoard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Application_Board",
    "data-name": "Application Board",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.119,
    height: 63.296,
    viewBox: "0 0 54.119 63.296",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M44.012,0H5.6A7.872,7.872,0,0,0-2.251,7.89V55.384A7.873,7.873,0,0,0,5.583,63.3H44.551a7.332,7.332,0,0,0,7.316-7.349V7.912A7.873,7.873,0,0,0,44.035,0ZM14.048,3.165H35.569v7.024a1.534,1.534,0,0,1-1.548,1.521H15.634a1.535,1.535,0,0,1-1.586-1.483V3.165ZM48.7,55.923a4.165,4.165,0,0,1-4.121,4.208H5.6A4.7,4.7,0,0,1,.914,55.413V7.912A4.705,4.705,0,0,1,5.576,3.165h5.307v7.024A4.7,4.7,0,0,0,15.6,14.875h18.38a4.7,4.7,0,0,0,4.75-4.656V3.165h5.279A4.7,4.7,0,0,1,48.7,7.883Zm0,0",
    transform: "translate(2.251)",
    fill: "#009639"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M90.368,209.415h11.981a1.582,1.582,0,1,0,0-3.165H90.368a1.582,1.582,0,0,0,0,3.165Zm0,0",
    transform: "translate(-77.261 -180.14)",
    fill: "#009639"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M118.272,286.25h-27.9a1.582,1.582,0,0,0,0,3.165h27.9a1.582,1.582,0,0,0,0-3.165Zm0,0",
    transform: "translate(-77.261 -250.013)",
    fill: "#009639"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M118.272,366.25h-27.9a1.582,1.582,0,0,0,0,3.165h27.9a1.582,1.582,0,1,0,0-3.165Zm0,0",
    transform: "translate(-77.261 -319.886)",
    fill: "#009639"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationBoard);
export default __webpack_public_path__ + "static/media/ApplicationBoard.c7f5f2b76f6048d0beb6de77141e9b07.svg";
export { ForwardRef as ReactComponent };